import { log } from './global-log'
import {
  currentEnvironment,
  getBuildTimeStamp,
  getDeploymentEnvironment,
  IConfiguration,
} from './helpers/environment'
import { CustomLogData } from './interfaces'

export function setupConfiguration(
  customMetadata?: CustomLogData,
  customSessionId?: string,
  contentStorageUrl?: string
): IConfiguration {
  const config: IConfiguration = {
    BuildTimeStamp: getBuildTimeStamp(),
    CustomMetadata: customMetadata,
    CustomSessionId: customSessionId,
    Environment: getDeploymentEnvironment(
      getUrlFromScriptTag(contentStorageUrl)
    ),
  }

  currentEnvironment.setConfiguration(config)
  log.setConfiguration(config)

  return config
}

function getUrlFromScriptTag(
  contentStorageUrl: string | undefined
): string | undefined {
  let url: string | null = ''
  if (contentStorageUrl !== undefined) {
    const node = document.querySelector(`script[src^="${contentStorageUrl}"]`)
    if (node) {
      url = node.getAttribute('src')
    }
  }

  return url || undefined
}
